import { api } from "./api";

const CHUNK = 4 * 1024 * 1024;

export async function uploadFileSmart(file, onProgress) {
  if (file.size <= CHUNK) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/files/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => e.total && onProgress?.(Math.round((e.loaded / e.total) * 100)),
    });
    return { path: data.path, name: file.name, content_type: data.content_type };
  }
  const uploadId = crypto.randomUUID();
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", String(i));
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
    await api.post("/files/upload-chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const { data } = await api.post("/files/upload-complete", {
    upload_id: uploadId,
    filename: file.name,
    total_chunks: total,
  });
  onProgress?.(100);
  return { path: data.path, name: file.name, content_type: data.content_type };
}
